const currentYear = new Date().getFullYear();

export const generalFields = {
  Drivers: [
    { key: 'brand', label: 'Brand *', type: 'text', placeholder: 'e.g. TaylorMade, Titleist, Ping', required: true },
    { key: 'model', label: 'Model *', type: 'text', placeholder: 'e.g. Stealth 2, TSR3, G430', required: true },
    { key: 'loft', label: 'Loft (Degrees) *', type: 'select', options: ['8.5', '9.0', '10.5', '12.0', 'Adjustable'], required: true },
    { key: 'shaftFlex', label: 'Shaft Flex *', type: 'select', options: ['Extra Stiff (X)', 'Stiff (S)', 'Regular (R)', 'Senior (A/M)', 'Ladies (L)'], required: true },
    { key: 'handedness', label: 'Handedness *', type: 'select', options: ['Right-Handed', 'Left-Handed'], required: true },
    { key: 'shaftMaterial', label: 'Shaft Material', type: 'select', options: ['Graphite', 'Steel'] },
    { key: 'headcover', label: 'Headcover Included', type: 'select', options: ['Yes', 'No'] },
    { key: 'adjustmentWrench', label: 'Adjustment Wrench Included', type: 'select', options: ['Yes', 'No', 'N/A'] },
  ],

  'Iron Sets': [
    { key: 'brand', label: 'Brand *', type: 'text', placeholder: 'e.g. Mizuno, Callaway, Srixon', required: true },
    { key: 'setMakeup', label: 'Set Makeup *', type: 'text', placeholder: 'e.g. 4-PW, 5-AW, 4-SW', required: true },
    { key: 'shaftFlex', label: 'Shaft Flex *', type: 'select', options: ['X-Stiff', 'Stiff', 'Regular', 'Senior', 'Ladies'], required: true },
    { key: 'shaftMaterial', label: 'Shaft Material *', type: 'select', options: ['Steel', 'Graphite', 'Multi-Material'], required: true },
    { key: 'handedness', label: 'Handedness *', type: 'select', options: ['Right-Handed', 'Left-Handed'], required: true },
    { key: 'lieAngle', label: 'Lie Angle', type: 'select', options: ['Standard', '1° Up', '2° Up', '1° Flat', '2° Flat'] },
    { key: 'length', label: 'Length', type: 'select', options: ['Standard', '+0.5"', '+1.0"', '-0.5"', '-1.0"'] },
  ],

  Putters: [
    { key: 'brand', label: 'Brand *', type: 'text', required: true },
    { key: 'putterType', label: 'Type *', type: 'select', options: ['Blade', 'Mallet', 'Mid-Mallet', 'Counterbalanced'], required: true },
    { key: 'length', label: 'Length (Inches) *', type: 'select', options: ['33"', '34"', '35"', 'Other'], required: true },
    { key: 'handedness', label: 'Handedness *', type: 'select', options: ['Right-Handed', 'Left-Handed'], required: true },
    { key: 'gripType', label: 'Grip Condition', type: 'select', options: ['New', 'Good', 'Needs Replacement'] },
  ],

  'Golf Bags': [
    { key: 'bagType', label: 'Bag Type *', type: 'select', options: ['Stand Bag', 'Cart Bag', 'Staff Bag', 'Sunday/Pencil Bag', 'Travel Cover'], required: true },
    { key: 'brand', label: 'Brand', type: 'text' },
    { key: 'numberOfDividers', label: 'Dividers', type: 'select', options: ['3-way', '4-way', '5-way', '14-way', 'Other'] },
    { key: 'waterproof', label: 'Waterproof', type: 'select', options: ['Yes', 'No'] },
  ],

  'Tech & Rangefinders': [
    { key: 'deviceType', label: 'Device Type *', type: 'select', options: ['Laser Rangefinder', 'GPS Watch', 'Handheld GPS', 'Launch Monitor'], required: true },
    { key: 'brand', label: 'Brand', type: 'text', placeholder: 'e.g. Bushnell, Garmin, ShotScope' },
    { key: 'slopeFunction', label: 'Slope Function', type: 'select', options: ['Yes', 'No', 'N/A'] },
    { key: 'batteryCondition', label: 'Battery/Charging Port Status', type: 'select', options: ['Working', 'Minor Issues', 'Not Working'] },
  ],

  Apparel: [
    { key: 'itemType', label: 'Type *', type: 'select', options: ['Polo', 'Shorts', 'Trousers', 'Outerwear', 'Cap/Visor', 'Belt'], required: true },
    { key: 'gender', label: 'Gender *', type: 'select', options: ['Men', 'Women', 'Junior', 'Unisex'], required: true },
    { key: 'brand', label: 'Brand', type: 'text' },
    { key: 'size', label: 'Size', type: 'select', options: ['S', 'M', 'L', 'XL', 'XXL', 'Standard Fit', 'Slim Fit'] },
  ],

  'Golf Shoes': [
    { key: 'shoeType', label: 'Type *', type: 'select', options: ['Spiked', 'Spikeless'], required: true },
    { key: 'sizeUK', label: 'Size (UK) *', type: 'number', min: 3, max: 15, required: true },
    { key: 'waterproofGuarantee', label: 'Waterproof Guarantee', type: 'select', options: ['Still Valid', 'Expired', 'No Guarantee'] },
  ],
};
